export default {
  red_100: '#FFF2F2',
  red_400: '#BF0B0E',
  red_500: '#E52427',
  red_v500: '#FF383B',

  red_alt: '#FF383B',

  black: '#000000',
  off_black: '#00151E',
  white: '#ffffff',

  grey_100: '#F2F2F3',
  grey_200: '#E1E1E2',
  grey_300: '#D0D0D2',
  grey_400: '#BDBDBF',
  grey_500: '#A1A1A6',
  grey_700: '#7D7D82',
  grey_900: '#283D46',

  blue_100: '#0E73C033',
  blue_300: '#0E73C063',
  blue_500: '#0E73C0',

  blue_alt: '#005DCA',

  green_500: '#1D9E6F',
  green_800: '#52AF52',

  green_alt: '#18D049',

  yellow_500: '#FFD700',
  yellow_alt: '#F3DD1C',
  yellow_warning: 'rgba(255, 215, 0, 0.25)',

  error_text: '#897306',

  orange_500: '#F77700',
};
